import {
  BagCheckoutContainer,
  BagContentContainer,
  BagDynamicModal,
  BagPaymentElementContainer,
  BagPaymentHeaderContainer,
  BagScrollView,
} from './Containers';
import {
  BagCheckoutCta,
  BagCheckoutSessionCta,
  BagContinueToCheckoutCta,
  BagCreditToggle,
  BagFloatingCtas,
  BagPaymentMethods,
  BagRedeemGiftCardCta,
  BagUtensilsCta,
  BagViewMenuCta,
  BagUseCardButton,
} from './Ctas';
import { BagDisclaimers } from './Disclaimers';
import { BagDisclosure } from './Disclosure';
import { BagDiscount, BagFooter, BagGroupOrderFooter, BagSubtotal } from './Footer';
import { BagGiftCardForm } from './GiftCard';
import {
  BagAnimatedDialogTitle,
  BagChannelHeader,
  BagHeaderContainer,
  BagLocationAtConnector,
  BagLocationFromConnector,
  BagLocationHeader,
  BagLocationToConnector,
  BagTimeConnector,
  BagTimeHeader,
} from './Header';
import { BagHeaderLine } from './Header/BagHeaderLine';
import { BagLedger } from './Ledger';
import { BagOrderPlayback } from './OrderPlayback';
import { BagDropoffLocationPicker, BagTimePicker } from './Pickers';
import { BagPriceSummary } from './PriceSummary';
import { BagPromoField, BagPromoRewardsContainer } from './PromoRewards';
import { BagEmptyState, BagLoadingOpacity, BagLoadingState } from './States';
import { BagUpsell } from './Upsell';
import {
  BagFutureDateWarning,
  BagNextDayOrderWarning,
  BagTimeslotUnavailableWarning,
  BagWarningModal,
} from './Warnings';

export { prepareLedger } from '../utils';
export { type OrderPlaybackConfig } from './OrderPlayback';

export const Bag = {
  //
  // ─── Containers ───────────────────────────────────────────────────────────

  DynamicModal: BagDynamicModal,
  ScrollView: BagScrollView,
  ContentContainer: BagContentContainer,
  CheckoutContainer: BagCheckoutContainer,
  PaymentElementContainer: BagPaymentElementContainer,
  PaymentHeaderContainer: BagPaymentHeaderContainer,

  // ─── States ───────────────────────────────────────────────────────────────

  LoadingOpacity: BagLoadingOpacity,
  LoadingState: BagLoadingState,
  EmptyState: BagEmptyState,

  // ─── Warnings ─────────────────────────────────────────────────────────────

  WarningModal: BagWarningModal,
  FutureDateWarning: BagFutureDateWarning,
  TimeslotUnavailableWarning: BagTimeslotUnavailableWarning,
  NextDayOrderWarning: BagNextDayOrderWarning,

  // ─── Order Playback ───────────────────────────────────────────────────────

  OrderPlayback: BagOrderPlayback,

  // ─── Pickers ──────────────────────────────────────────────────────────────

  TimePicker: BagTimePicker,
  DropoffLocationPicker: BagDropoffLocationPicker,
  CheckoutSessionCta: BagCheckoutSessionCta,
  RedeemGiftCardCta: BagRedeemGiftCardCta,

  // ─── Header ───────────────────────────────────────────────────────────────

  AnimatedDialogTitle: BagAnimatedDialogTitle,
  HeaderLine: BagHeaderLine,
  ChannelHeader: BagChannelHeader,
  HeaderContainer: BagHeaderContainer,
  LocationFromConnector: BagLocationFromConnector,
  LocationHeader: BagLocationHeader,
  LocationToConnector: BagLocationToConnector,
  LocationAtConnector: BagLocationAtConnector,
  TimeConnector: BagTimeConnector,
  TimeHeader: BagTimeHeader,

  // ─── Promo Code Rewards ───────────────────────────────────────────────────

  PromoRewardsContainer: BagPromoRewardsContainer,
  PromoField: BagPromoField,

  // ─── Giftcard ─────────────────────────────────────────────────────────────

  GiftCardForm: BagGiftCardForm,

  // ─── Disclosure ───────────────────────────────────────────────────────────

  Disclosure: BagDisclosure,

  // ─── Footer ───────────────────────────────────────────────────────────────

  Footer: BagFooter,
  GroupOrderFooter: BagGroupOrderFooter,
  Subtotal: BagSubtotal,
  Discount: BagDiscount,
  Disclaimers: BagDisclaimers,

  // ─── Checkout ─────────────────────────────────────────────────────────────

  CreditToggle: BagCreditToggle,
  Ledger: BagLedger,
  PaymentMethods: BagPaymentMethods,
  PriceSummary: BagPriceSummary,

  // ─── CTAs ─────────────────────────────────────────────────────────────────

  ViewMenuCta: BagViewMenuCta,
  UtensilsCta: BagUtensilsCta,
  ContinueToCheckoutCta: BagContinueToCheckoutCta,
  FloatingCtas: BagFloatingCtas,
  CheckoutCta: BagCheckoutCta,
  UseCardButton: BagUseCardButton,

  // ─── Upsell ───────────────────────────────────────────────────────────────────
  Upsell: BagUpsell,
};
